import { Suspense } from 'react';
import { AppProviders } from '@/core/components/providers/AppProviders';
import { AppRoutes } from '@/core/components/routing/AppRoutes';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
/**
 * App - Root Application Component
 * Clean, minimal entry point using atomic design
 *
 * Note: cortex_session handling is managed by InitializeAuthUseCase
 * which runs in AppRoutes - this is the single source of truth
 */

const queryClient = new QueryClient();

// Loading fallback for i18n Suspense
const I18nLoadingFallback = () => (
  <div className="flex items-center justify-center h-screen bg-white">
    <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-gray-500" />
  </div>
);

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppProviders>
        <Suspense fallback={<I18nLoadingFallback />}>
          <AppRoutes />
        </Suspense>
      </AppProviders>
    </QueryClientProvider>
  );
};

export default App;
